module.exports = __webpack_public_path__ + "static/img/DEAN_JONES.ca880e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DEAN_JONES.jpg
// module id = SpEo
// module chunks = 0